import { Component, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractControlDirective } from '@cupoui/shared/components/abstract-control.directive';

@Component({
    selector: 'app-input-date-time',
    templateUrl: './input-date-time.component.html',
    styleUrls: ['./input-date-time.component.scss'],
    //  encapsulation: ViewEncapsulation.None,
    providers: [
        //    { provide: DateAdapter, useClass: AppDateAdapter },
        //    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
        {
            provide: NG_VALUE_ACCESSOR,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            useExisting: forwardRef(() => InputDateTimeComponent),
            multi: true
        }
    ],
    standalone: false
})
export class InputDateTimeComponent extends AbstractControlDirective {
  public dateTimeControl: FormControl = new FormControl();

  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: Date;
  public maxDate: Date;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  //  public color: ThemePalette = 'primary'; [color]="color"
  public disableMinute = false;
  public hideTime = false;

  constructor() {
    super();
    this.subscriptions.push(
      this.dateTimeControl.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  public writeValue(value: string | null): void {
    value = value === undefined ? null : value;
    this.dateTimeControl.patchValue(value, { emitEvent: false });
  }

  public setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.dateTimeControl.disable({ emitEvent: false });
    } else {
      this.dateTimeControl.enable({ emitEvent: false });
    }
  }
}
